import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'wz-bulletin-adhesion-dialog',
  templateUrl: './bulletin-adhesion-dialog.component.html',
  styleUrls: ['./bulletin-adhesion-dialog.component.scss'],
  standalone: false,
})
export class BulletinAdhesionDialogComponent implements OnInit {
  src!: SafeResourceUrl | null;
  constructor(
    public dialogRef: MatDialogRef<BulletinAdhesionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.setUrl(this.data.src);
  }

  //url example: string = "https://therichpost.com/sample.pdf#toolbar=0&navpanes=0&scrollbar=0";
  //Transform Url TO MAKE IT working with iframe:
  setUrl(url: string) {
    this.cleanup();
    setTimeout(() => {
      this.src = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }, 50);
  }

  cleanup() {
    this.src = null;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}

interface DialogData {
  src: string;
  title: string;
}
